import React from "react"

import GridIcon from '@material-ui/icons/ViewCompact'
import ListIcon from '@material-ui/icons/List'

import MediaContainer   from '../../display/containers/MediaContainer'
import MediaObjectsList from '../../display/lists/MediaObjectsList'

import initView from '../../display/views/initView'
import View     from '../../display/views/TabsView'

import api from '../../configs/api'

const styles = () => ({}) ;

const path = api.mediaObjects ;

const { url:uri } = path ;

class MediaObjects extends View
{
    getLocale = () => this.props.locale.views.mediaObjects ;
}

MediaObjects.defaultProps =
{
    ...View.defaultProps,
    first  : 'grid' ,
    path,
    routes :
    [
        { id : 'grid' , Component: MediaContainer   , uri , backPath: '/grid' },
        { id : 'list' , Component: MediaObjectsList , uri , backPath: '/list' }
    ],
    tabs :
    [
        { id : 'grid' , icon : <GridIcon /> } ,
        { id : 'list' , icon : <ListIcon /> }
    ]
};

MediaObjects.propTypes =
{
    ...View.propTypes,
};

export default initView( MediaObjects , styles ) ;
